import { WithChildren } from 'src/utils/UtilityTypes';

export const VaultOverviewSectionBox = ({ children }: WithChildren) => {
	return (
		<div className="flex w-full flex-col gap-4 rounded-sm bg-container-bg p-4 typo-b4 text-text-secondary">
			{children}
		</div>
	);
};
